import { useCallback } from "react";
import makeClassName from "./utils/makeClassName";
var useClassName = function(param) {
    var name = param.name;
    var prefix = 'carina';
    return useCallback(function(element, modifier) {
        return makeClassName(prefix, name, element, modifier);
    }, [
        prefix,
        name
    ]);
};
export default useClassName;
export { useClassName };
